import { createContext, useContext, useState, useCallback } from "react";

const UnifiedSessionContext = createContext(null);

export const UnifiedSessionProvider = ({ children }) => {
  const [sessionToken, setSessionToken] = useState(null);
  const [sessionData, setSessionData] = useState(null);

  const clearSession = useCallback(() => {
    setSessionToken(null);
    setSessionData(null);
  }, []);

  return (
    <UnifiedSessionContext.Provider
      value={{ sessionToken, setSessionToken, sessionData, setSessionData, clearSession }}
    >
      {children}
    </UnifiedSessionContext.Provider>
  );
};

export const useUnifiedSession = () => {
  const context = useContext(UnifiedSessionContext);
  if (!context) {
    throw new Error("useUnifiedSession must be used within UnifiedSessionProvider");
  }
  return context;
};

